import { Col, ColorPicker as ColorPickerAntd, Divider, Row } from 'antd';
import styles from './colorPicker.module.scss';
import type { ColorPickerProps } from 'antd';
import { PresetsItem } from 'antd/es/color-picker/interface';
import React, { CSSProperties } from 'react';
import { Color } from 'antd/es/color-picker';

const recommendedColors: string[] = [
	'#FF8080',
	'#FFFF80',
	'#80FF80',
	'#00FF80',
	'#80FFFF',
	'#0080FF',
	'#FF80C0',
	'#FF80FF',
	'#FF0000',
	'#FFFF00',
	'#80FF00',
	'#00FF40',
	'#00FFFF',
	'#0080C0',
	'#8080C0',
	'#FF00FF',
	'#804040',
	'#FF8040',
	'#00FF00',
	'#008080',
	'#004080',
	'#8080FF',
	'#800040',
	'#FF0080',
	'#800000',
	'#FF8000',
	'#008000',
	'#008040',
	'#0000FF',
	'#0000A0',
	'#800080',
	'#8000FF',
	'#400000',
	'#804000',
	'#004000',
	'#004040',
	'#000080',
	'#000040',
	'#400040',
	'#400080',
	'#000000',
	'#808000',
	'#808040',
	'#808080',
	'#408080',
	'#FFFFFF',
	'#C0C0C0',
];
const defaultPresets: PresetsItem[] = [
	{
		label: _('BasicColors'),
		colors: recommendedColors,
	},
];

type ColorPickerStyle = {
	popup?: CSSProperties;
	popupOverlayInner?: CSSProperties;
};

type Props = {
	value: string;
	horizontal?: boolean;
	presets?: PresetsItem[];
	colorPickerStyles?: ColorPickerStyle;
	onChange: (value: Color) => void;
};

const ColorPicker: React.FC<Props> = ({ value, horizontal, presets, colorPickerStyles, onChange }) => {
	const defaultPanelRender = (panel: React.ReactNode) => panel;

	const customPanelRender: ColorPickerProps['panelRender'] = (_, { components: { Picker, Presets } }) => (
		<Row justify='space-between' wrap={false} className={styles.pickerContent}>
			<Col span={12}>
				<Presets />
			</Col>
			<Divider type='vertical' className={styles.divider} />
			<Col flex='auto'>
				<Picker />
			</Col>
		</Row>
	);

	const currentPresets: PresetsItem[] = presets || defaultPresets;
	const panelRender = horizontal ? customPanelRender : defaultPanelRender;
	const currentColorPickerStyles: ColorPickerStyle = colorPickerStyles || { popupOverlayInner: { width: 480 } };

	return (
		<ColorPickerAntd
			className={styles.colorPicker}
			defaultValue={'#000000'}
			styles={currentColorPickerStyles}
			presets={currentPresets}
			panelRender={panelRender}
			value={value}
			onChangeComplete={onChange}
		/>
	);
};

export { ColorPicker };
